import { render, staticRenderFns } from "./ChartPoliticiansForEachRegion.vue?vue&type=template&id=1a8bbb99&"
import script from "./ChartPoliticiansForEachRegion.vue?vue&type=script&lang=js&"
export * from "./ChartPoliticiansForEachRegion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ChartPoliticiansForEachRegion.vue?vue&type=custom&index=0&blockType=tsv"
if (typeof block0 === 'function') block0(component)

export default component.exports